//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { memberCulomn } from '@/const/constants';
import {
  getStatis,
  getMemberPerformance
} from '@/api/activity';
import UBT from '@/utils/ubt';

export default {
  filters: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  data() {
    const { month, year } = this.$route.query;
    const fullYear = year || new Date().getFullYear();
    const m = +month || (new Date().getMonth() + 1);
    const fullMonth = m < 10 ? `0${m}` : m;
    const queryDate = `${fullYear}-${fullMonth}-01`;
    return {
      arrowStatus: true,
      hasLeft: false,
      hasRight: false,
      scrollValue: 0,
      columns: [],
      cardType: 1,
      statis: {},
      showPopupPicker: false,
      tableData: [],
      fullMonth,
      fullYear,
      pageIndex: 1,
      pageSize: 15,
      queryDate,
      activityId: this.$route.query.activityId,
      roleType: this.$route.query.roleType,
      subRoleType: this.$route.query.subRoleType,
      tableHeight: 0,
      userId: '',
    };
  },
  computed: {
    ...mapState({
      userNewId: state => state.user.loginResult.userNewId,
    }),
  },
  mounted() {
    const {
      activityId, roleType, sourceId,
      userId, nickName,
    } = this.$route.query;
    this.userId = userId || '';
    if (nickName) {
      document.title = `${nickName}的绩效`;
    }
    if (
      +roleType !== +this.$store.state.user.loginResult.roleType
        || +activityId !== +this.$store.state.user.loginResult.activityId
        || (this.$store.state.user.loginResult.sourceId
         && sourceId !== this.$store.state.user.loginResult.sourceId)
    ) {
      this.$router.replace({
        name: 'login',
        query: this.$route.query
      });
      this.$throw(new Error('登录已失效，请重新登录'));
      return;
    }
    this.columns = memberCulomn;
    window.onresize = this.setTableShadow;
    window.onload = this.setTableShadow;
    UBT.pageView({
      pageId: 'H5_换电_队员绩效页',
    });
    this.initData();
    this.$nextTick(() => {
      setTimeout(() => {
        const dom = document.querySelector('.table-body');
        if (dom) {
          dom.addEventListener('scroll', (e) => {
            const {
              offsetHeight,
              scrollTop,
              scrollHeight
            } = e.srcElement;
            if (scrollHeight - offsetHeight - 10 < scrollTop) {
              this.pageIndex += 1;
              this.loadMemberPage({ userId: this.userId, type: this.cardType });
            }
          });
        }
      }, 1000);
    });
  },
  methods: {
    initData() {
      this.getStatData({ userId: this.userId, type: 2 });
      this.loadMemberPage({ userId: this.userId, type: 1 });
    },
    /**
     * 获取统计数据
     */
    async getStatData({ userId, type }) {
      this.statis = await getStatis({
        activityId: this.activityId,
        userId,
        type,
        queryDate: this.queryDate,
      });
    },

    /**
     * 获取队员数据
     */
    async loadMemberPage({ userId, type }) {
      const data = await getMemberPerformance({
        activityId: this.activityId,
        userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        type,
        queryDate: this.queryDate,
      });
      this.tableData = this.tableData.concat(data.list || []);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    handleBodyScroll() {
      this.scrollValue = this.$refs.tableScroll.scrollLeft;
      this.hasRight = this.scrollValue - this.leftScroll < 0;
      this.hasLeft = this.scrollValue > 0;
      this.$refs.scrollHead1.scrollLeft = this.scrollValue;
    },
    setTableShadow() {
      this.leftScroll = this.$refs.tableContent.clientWidth - this.$refs.tableScroll.clientWidth;
      this.handleBodyScroll();
    },
    tabChange(type) {
      this.cardType = type;
      this.pageIndex = 1;
      this.tableData = [];
      this.loadMemberPage({ userId: this.userId, type });
    },
    onChange() {
      const that = this;
      this.arrowStatus = false;
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM',
        value: `${this.fullYear}-${this.fullMonth}`,
        onHide() {
          that.arrowStatus = true;
        },
        onConfirm(date) {
          that.arrowStatus = true;
          if (date !== `${that.fullYear}-${that.fullMonth}`) {
            [that.fullYear, that.fullMonth] = date.split('-');
            that.statis = [];
            that.tableData = [];
            that.pageIndex = 1;
            that.queryDate = `${date}-01`;
            that.initData();
          }
        },
      });
    },

  },
};
